<span>{{ content$ | async }}</span>
